import React from "react";
import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { Link } from "react-router-dom";

import { BaseLayout } from "../layouts/BaseLayout";
import { PageContainer } from "../components/PageContainer/PageContainer";
import { AlbumSearch } from "../components/AlbumSearch/AlbumSearch";
import { H1, Paragraph } from "../components/Typography/Typography";

import "./Search.scss";

export function Search() {
    return (
        <BaseLayout className="search-page">
            <PageContainer>
                <H1 variant="heading-2" fontFamily="sans-serif">
                    Find an album and share it with your friends
                </H1>
                <Paragraph variant="body-2" color="mid-contrast">
                    Spot something you love? Don’t be selfish—share the vibe.
                </Paragraph>
           

                <SignedIn>
                    <AlbumSearch />
                </SignedIn>

                <SignedOut>
                    <Paragraph className="search-page__sign-in" variant="body-2">
                        <Link to="/login">Sign in</Link> to search and recommend albums.
                    </Paragraph>
                </SignedOut>
            </PageContainer>
        </BaseLayout>
    );
}
